module.exports = __webpack_public_path__ + "static/media/hair-2.cefc0ab4.svg";